import Link from "next/link";
import { ReactNode } from "react";
import { cn } from "~/utils/fontsConfig";

const Chip = ({
    children,
    href,
    className,
}: {
    children: ReactNode;
    href?: string | undefined;
    className?: string;
}) => {
    if (!href) {
        return (
            <div
                className={cn(
                    "mt-4 w-max max-w-max select-none rounded-full border-[1px] border-white px-6 py-1 font-ibm-plex-mono uppercase text-white",
                    className,
                )}
            >
                {children}
            </div>
        );
    }

    return (
        <Link
            href={href}
            className={cn(
                "mt-4 w-max max-w-max select-none rounded-full border-[1px] border-white px-6 py-1 font-ibm-plex-mono uppercase text-white hover:border-secondary",
                className,
            )}
        >
            {children}
        </Link>
    );
};

export default Chip;
